import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { KomisiFormPayload } from "./validation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";

// get
const getKomisi = async (
  query?: string
): Promise<ApiResponse<DataPaginate<KomisiResponse>>> => {
  return await fetcher(query ? `master/komisi?${query}` : `master/komisi`);
};

export const useGetKomisi = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<KomisiResponse>>, Error>(
    ["useGetKomisi", query],
    () => getKomisi(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getKomisiId = async (
  id: number
): Promise<ApiResponse<DataObject<KomisiResponse>>> => {
  return await fetcher(`master/komisi/${id}`);
};

export const useGetKomisiId = (id: number) => {
  return useQuery<ApiResponse<DataObject<KomisiResponse>>, Error>(
    ["useGetKomisiId", id],
    () => getKomisiId(id)
  );
};

// post
export const useKomisi = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<KomisiFormPayload>>,
    Error,
    KomisiFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<KomisiFormPayload>>> => {
      const endpoint = id ? `master/komisi/${id}` : "master/komisi";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<KomisiFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
